const checkoutUserStep = {
  login: 'Anmelden',
  register: 'Neu registrieren',
  guest: 'Gastbestellung',
  sidebar: {
    loginDescription: 'Bitte melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.',
    registerDescription1: 'Bei der nächsten Bestellung noch mehr Zeit sparen',
    registerDescription2: 'Lieblings-Apotheke unterstützen',
    registerDescription3: 'IhreApotheken-App kostenfrei mitnutzen',
    registerDescription4: 'my life E-Paper kostenlos erhalten',
    guestDescription: 'Ich verzichte auf die Vorteile des IhreApotheken-Kontos',
  },
  forms: {
    nameTitle: 'Wie sollen wir Sie ansprechen?',
    salutation: 'Anrede',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    accountTitle: 'IhreApotheken-Konto anlegen',
    email: 'E-Mail-Adresse *',
    password: 'Passwort *',
    passwordHint: 'Hinweis:',
    passwordHintText: 'Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl enthalten',
    phoneTitle: 'Wie kann die Apotheke Sie erreichen?',
    phoneNumber: 'Telefonnummer *',
    ourPromise: 'Unser Versprechen:',
    promiseText: 'Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
    pleaseFill: 'Bitte füllen Sie die Pflichtfelder aus',
    rememberMe: 'An mich erinnern',
    forgotPassword: 'Passwort vergessen?',
    back: 'Zurück',
    continue: 'Weiter',
    newsletter: 'Melden Sie sich hiermit für unseren kostenfreien Newsletter an und profitieren Sie von regelmäßigen Produktempfehlungen und Neuigkeiten rund um Ihre Apotheke. Die Anmeldung zum Newsletter ist freiwillig und kann jederzeit widerrufen werden.',
  },
}

export default checkoutUserStep
